<a *ngIf="email" href="mailto:{{email}}" matTooltip="Click to e-mail {{email}}">{{email}}</a>
